import mapValues from 'lodash/mapValues';
import mergeWith from 'lodash/mergeWith';
import uniq from 'lodash/uniq';

/**
 * Merges multiple objects, combining the values of the objects if matching keys are found, instead of overriding them. Useful for merging objects with string values, such as LanguageInterface.
 * @example
 * ```typescript
 * mergeObjectsWithContent({ a: 'hello' }, { a: 'world' }) // { a: 'helloworld' }
 * ```
 */
const toArray = (value: unknown): unknown[] => {
  if (Array.isArray(value)) {
    return value;
  }
  if (value !== undefined) {
    return [value];
  }
  return [];
};

const mergeObjectsWithContent = (
  ...objs: Record<string, unknown>[]
): Record<string, string> =>
  mapValues(
    mergeWith({}, ...objs, (a, b) => {
      const arrA = toArray(a);
      const arrB = toArray(b);
      return arrA.concat(arrB);
    }),
    (v) => (Array.isArray(v) ? uniq(v).join('') : String(v)),
  );

export { mergeObjectsWithContent };
